export default "__VITE_ASSET__$q3_0CAP__"